export var searchForNestedObject = function (input, key) {
    if (!input) {
        return null;
    }
    if (input.hasOwnProperty(key)) {
        return input;
    }
    for (var i = 0; i < Object.keys(input).length; i++) {
        var nextInputObject = input[Object.keys(input)[i]];
        if (typeof nextInputObject === 'object') {
            var o = searchForNestedObject(nextInputObject, key);
            if (o !== null) {
                return o;
            }
        }
    }
    return null;
};
//# sourceMappingURL=searchForNestedObject.js.map